import React, { useMemo } from "react";
import PropTypes from "prop-types";
import WindowProvider from "./WindowProvider";
import BreakpointProvider from "./BreakpointProvider";
import LinkProvider from "./LinkProvider";
import { ThemeContext } from "../hooks/useTheme";
import { enhanceTheme } from "../utils/theme";
import FocusVisiblePolyfill from "../components/internal/FocusVisiblePolyfill";
import { jsx as ___EmotionJSX } from "@emotion/core";

function BasisProvider(_ref) {
  var theme = _ref.theme,
      window = _ref.window,
      InternalLink = _ref.InternalLink,
      isLinkInternal = _ref.isLinkInternal,
      children = _ref.children;
  var enhancedTheme = useMemo(function () {
    return enhanceTheme(theme);
  }, [theme]);
  return ___EmotionJSX(ThemeContext.Provider, {
    value: enhancedTheme
  }, ___EmotionJSX(WindowProvider, {
    window: window
  }, ___EmotionJSX(FocusVisiblePolyfill, null), ___EmotionJSX(BreakpointProvider, null, ___EmotionJSX(LinkProvider, {
    InternalLink: InternalLink,
    isLinkInternal: isLinkInternal
  }, children))));
}

BasisProvider.propTypes = {
  theme: PropTypes.object.isRequired,
  window: PropTypes.object,
  InternalLink: PropTypes.elementType,
  isLinkInternal: PropTypes.func,
  children: PropTypes.node.isRequired
};
export default BasisProvider;